import { render } from "./ClassesSection.vue?vue&type=template&id=f09fd214&scoped=true"
const script = {}

import "./ClassesSection.vue?vue&type=style&index=0&id=f09fd214&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f09fd214"]])

export default __exports__